/**
 * Site-wide constants. The canonical host is intentionally hardcoded —
 * SEO memory `seo/optimization-standards-v3` requires every canonical URL
 * to use `https://brrgr.com` regardless of where the SPA is served from
 * (preview domains, native shells, custom domains).
 */

export const SITE_URL = "https://brrgr.com" as const;
export const SITE_DOMAIN = "brrgr.com" as const;
export const CONTACT_EMAIL = "info@brrgr.com" as const;

/** Build a canonical absolute URL for a given path. */
export const canonicalUrl = (path: string = "/"): string => {
  if (!path.startsWith("/")) path = `/${path}`;
  return `${SITE_URL}${path === "/" ? "" : path}`;
};

/** Standard breadcrumb root used by every page's JSON-LD. */
export const HOME_BREADCRUMB = { name: "Home", url: SITE_URL } as const;
